import { render, staticRenderFns } from "./summaryCount.vue?vue&type=template&id=54afd696&scoped=true"
import script from "./summaryCount.vue?vue&type=script&lang=js"
export * from "./summaryCount.vue?vue&type=script&lang=js"
import style0 from "./summaryCount.vue?vue&type=style&index=0&id=54afd696&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afd696",
  null
  
)

export default component.exports